export enum GuestWalletEntryType {
  TOP_UP = "TOP_UP",
  CONSUMPTION = "CONSUMPTION",
  ADJUSTMENT = "ADJUSTMENT",
}

export interface GuestWalletEntry {
  id: string;
  type: GuestWalletEntryType;
  amount: number;
  balanceAfter: number;
  currency: string;
  note?: string | null;
  actorUserId?: string | null;
  bookingId?: string | null;
  serviceRequestId?: string | null;
  transactionId?: string | null;
  metadata?: Record<string, unknown> | null;
  createdAt: Date | string;
}

export interface BookingPaymentSummary {
  bookingId: string;
  guestId: string;
  hotelId: string;
  currency: string;
  outstandingAmount: number;
  walletBalanceAmount: number;
  walletAppliedAmount: number;
  stripeRemainderAmount: number;
  recentWalletEntries: GuestWalletEntry[];
}

export interface TopUpGuestWalletPayload {
  amount: number;
  note?: string;
}

export interface GuestWalletTopUpResponse {
  walletId: string;
  entryId: string;
  guestId: string;
  hotelId: string;
  amount: number;
  balanceAmount: number;
  currency: string;
  note?: string;
  createdAt: Date | string;
}
